export default "__VITE_ASSET__ONHgZ_0f__"